<template>
  <div class="modal" @click.self="closeModal">
    <div v-if="isWaiting" class="loading-overlay">
      <div class="lds-dual-ring"></div>
    </div>
    <div class="modal-content confirm-modal">
      <div class="modal-header">
        <div class="title">
          <h5>{{ localization.error_title }}</h5>
        </div>
      </div>
      <div class="modal-body" v-html="localization.error_text"></div>

      <div class="modal-footer">
        <button class="modal-btn cancel" @click.self="closeModal">
          {{ localization.skip_button }}
        </button>
        <button class="modal-btn confirm" @click.self="resubmit">
          {{ localization.resubmit_button }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ErrorModal",
  computed: {
    ...mapGetters("project", ["localization"]),
    ...mapGetters("videoPlayer", ["isWaiting"]),
  },
  methods: {
    closeModal() {
      this.$emit("close-error-modal");
      this.$store.dispatch("videoPlayer/goFinalStep", true);
    },
    resubmit() {
      this.$store.dispatch("videoPlayer/resubmit", true);
    },
  },
};
</script>

<style></style>
